import type {
  FilterGroup,
  FilterInput,
} from '@/components/publicSearch/constants';
import { hasFilterCriteria } from '@/hooks/publicSearch/hasFilterCriteria';

/** Match the active filter source; empty editor rows are not a search. */
export function hasAnimalSearchCriteria(
  filters: FilterInput[],
  filterGroups: FilterGroup[],
  myAnimals: boolean,
  animalsOnSaleOnly: boolean,
): boolean {
  return (
    myAnimals || animalsOnSaleOnly || hasFilterCriteria(filters, filterGroups)
  );
}
